import React from 'react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';

type TypographyTags = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'em' | 'small';

interface TypographyProps extends IClassNames {
  /**
   * HTML tag that will be rendered
   */
  variant?: TypographyTags;

  /**
   * Styling that will be applied, defaults to the variant
   */
  as?: TypographyTags;

  /**
   * HTML Id
   */
  id?: string;
}

const Typography: React.FC<TypographyProps> = ({
  variant = 'p',
  as,
  children,
  classNames,
  ...props
}) => {
  const { className } = useClassNames(as, classNames);
  const Tag = variant;

  return (
    <Tag className={className} {...props}>
      {children}
    </Tag>
  );
};

export default Typography;
